import { atomWithQuery } from 'jotai-tanstack-query';
import { NnSundVaegtProgramDto } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { getOrCreateNnSundvaegtProgram } from '../api/getOrCreateNnSundvaegtProgram';

export const fetchNnSundvaegtProgramAtom = atomWithQuery<
    NnSundVaegtProgramDto | undefined
>(() => ({
    queryKey: ['nnsundvaegt-weightprogram'],
    queryFn: async () => {
        return getOrCreateNnSundvaegtProgram();
    },
    initialData: undefined,
    enabled: true,
}));
